











































import Vue from 'vue'
import { Observer } from 'mobx-vue'
import {Component, Prop, Inject} from 'vue-property-decorator'

import { ServerInfo, SystemStore } from '../../stores/System'
import { getAppLinks }             from  '../../rundeckService'
import { AppLinks }                from  '../../interfaces/AppLinks'
import { RootStore }               from  '../../stores/RootStore'

import RundeckVersion              from  '../version/RundeckVersionDisplay.vue'


@Observer
@Component({components: {
    RundeckVersion
}})
export default class FirstRun extends Vue {
    @Inject()
    rootStore!: RootStore

    @Prop()
    server!: ServerInfo
    
    links!: AppLinks
    loaded = false

    system!: SystemStore

    async created() {
      this.system = this.rootStore.system
      this.links = getAppLinks()

      try {
        await Promise.all([
          this.rootStore.system.load(),
          this.rootStore.releases.load()
        ])
      } catch(e) {}
      this.loaded = true
    }
 
}
